<template>
  <div class="btn-yellow">
    <a :href="url">
      <mdicon name="Cogs" class="flex justify-center text-white" size="90" />
      <h2 class=" text-white text-2xl text-center font-semibold mb-4">{{ title }}</h2>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: 'https://falabr.cgu.gov.br/publico/Manifestacao/SelecionarTipoManifestacao.aspx?ReturnUrl=%2f'
    }
  },
  props: {
    title: String
  },
}
</script>